import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BehaviorSubject, map, Observable, of} from "rxjs";
import {ActionResult, Club, Country, Lookups, Sport} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class CodebookService {
  genders: CodebookElement<Lookups>;
  sports: CodebookElement<Sport>;
  clubs: CodebookElement<Club>;
  sizes: CodebookElement<Lookups>;
  countries: CodebookElement<Country>;
  transports: CodebookElement<Lookups>;
  meals: CodebookElement<Lookups>;
  languages: CodebookElement<Lookups>;
  eventStatuses: CodebookElement<Lookups>;
  currencies: CodebookElement<Lookups>;
  requestStatuses: CodebookElement<Lookups>;
  requestTypes: CodebookElement<Lookups>;
  eventTypes: CodebookElement<Lookups>;
  raceStatuses: CodebookElement<Lookups>;
  raceRegistrationTypes: CodebookElement<Lookups>;
  scoringForTypes: CodebookElement<Lookups>;
  waypointTypes: CodebookElement<Lookups>;
  waypointMarkerTypes: CodebookElement<Lookups>;
  registrationFeeTypes: CodebookElement<Lookups>;
  applicationProcedureTypes: CodebookElement<Lookups>;
  typeOfApplicationTypes: CodebookElement<Lookups>;
  teamTypes: CodebookElement<Lookups>;
  selectionOfTeamMembersTypes: CodebookElement<Lookups>;
  measurementPrecisionTypes: CodebookElement<Lookups>;
  measurementTypes: CodebookElement<Lookups>;
  startByTypeTypes: CodebookElement<Lookups>;
  genderSeparationTypes: CodebookElement<Lookups>;
  teamRankingTeamSeparationTypes: CodebookElement<Lookups>;
  visibilityTypes: CodebookElement<Lookups>;
  rotatingOrderTypes: CodebookElement<Lookups>;
  registrationDisplayFlags: CodebookElement<Lookups>;
  categoryTypes: CodebookElement<Lookups>;
  fieldConfigTypes: CodebookElement<Lookups>;
  disciplines: CodebookElement<Lookups>;
  timingSystems: CodebookElement<Lookups>;
  timingEquipments: CodebookElement<Lookups>;
  eventPaymentTypes: CodebookElement<Lookups>;
  eventPaymentMethods: CodebookElement<Lookups>;
  eventPaymentReminderMethods: CodebookElement<Lookups>;
  leaguesCountries: CodebookElement<Country>;
  leaguesSports: CodebookElement<Sport>;

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {

    this.genders = new CodebookElement<Lookups>("/api/public/lookups/getgenders", http, environmentService);
    this.sports = new CodebookElement<Lookups>("/api/public/lookups/getsports", http, environmentService);
    this.clubs = new CodebookElement<Club>("/api/public/lookups/getclubs", http, environmentService);
    this.sizes = new CodebookElement<Lookups>("/api/public/lookups/getsize", http, environmentService);
    this.countries = new CodebookElement<Country>("/api/public/lookups/getcountries", http, environmentService);
    this.transports = new CodebookElement<Lookups>("/api/public/lookups/gettransport", http, environmentService);
    this.meals = new CodebookElement<Lookups>("/api/public/lookups/getmeals", http, environmentService);
    this.languages = new CodebookElement<Lookups>("/api/public/lookups/getlanguages", http, environmentService);
    this.eventStatuses = new CodebookElement<Lookups>("/api/public/lookups/statuses", http, environmentService);
    this.currencies = new CodebookElement<Lookups>("/api/public/lookups/getcurrencies", http, environmentService);
    this.requestStatuses = new CodebookElement<Lookups>("/api/public/lookups/requeststatus", http, environmentService);
    this.requestTypes = new CodebookElement<Lookups>("/api/public/lookups/requesttypes", http, environmentService);
    this.eventTypes = new CodebookElement<Lookups>("/api/public/lookups/eventtypes", http, environmentService);
    this.raceStatuses = new CodebookElement<Lookups>("/api/public/lookups/racestatuses", http, environmentService);
    this.raceRegistrationTypes = new CodebookElement<Lookups>("/api/public/lookups/raceregistrationtypes", http, environmentService);
    this.scoringForTypes = new CodebookElement<Lookups>("/api/public/lookups/scoringfortypes", http, environmentService);
    this.waypointTypes = new CodebookElement<Lookups>("/api/public/lookups/waypointtypes", http, environmentService);
    this.waypointMarkerTypes = new CodebookElement<Lookups>("/api/public/lookups/waypointmarkertypes", http, environmentService);
    this.registrationFeeTypes = new CodebookElement<Lookups>("/api/public/lookups/registrationfeetypes", http, environmentService);
    this.applicationProcedureTypes = new CodebookElement<Lookups>("/api/public/lookups/applicationproceduretypes", http, environmentService);
    this.typeOfApplicationTypes = new CodebookElement<Lookups>("/api/public/lookups/typeofapplicationtype", http, environmentService);
    this.teamTypes = new CodebookElement<Lookups>("/api/public/lookups/teamtypes", http, environmentService);
    this.selectionOfTeamMembersTypes = new CodebookElement<Lookups>("/api/public/lookups/selectionofteammemberstypes", http, environmentService);
    this.measurementPrecisionTypes = new CodebookElement<Lookups>("/api/public/lookups/measurementprecisiontypes", http, environmentService);
    this.measurementTypes = new CodebookElement<Lookups>("/api/public/lookups/measurementtypes", http, environmentService);
    this.startByTypeTypes = new CodebookElement<Lookups>("/api/public/lookups/startbytypes", http, environmentService);
    this.genderSeparationTypes = new CodebookElement<Lookups>("/api/public/lookups/genderseparationtypes", http, environmentService);
    this.teamRankingTeamSeparationTypes = new CodebookElement<Lookups>("/api/public/lookups/teamrankingteamseparationtypes", http, environmentService);
    this.visibilityTypes = new CodebookElement<Lookups>("/api/public/lookups/visibilitytypes", http, environmentService);
    this.rotatingOrderTypes = new CodebookElement<Lookups>("/api/public/lookups/rotatingordertypes", http, environmentService);
    this.registrationDisplayFlags = new CodebookElement<Lookups>("/api/public/lookups/registrationdisplayflag", http, environmentService);
    this.categoryTypes = new CodebookElement<Lookups>("/api/public/lookups/categorytypes", http, environmentService);
    this.fieldConfigTypes = new CodebookElement<Lookups>("/api/public/lookups/fieldconfigtypes", http, environmentService);
    this.disciplines = new CodebookElement<Lookups>("/api/public/lookups/disciplines", http, environmentService);
    this.timingSystems = new CodebookElement<Lookups>("/api/public/lookups/timingsystems", http, environmentService);
    this.timingEquipments = new CodebookElement<Lookups>("/api/public/lookups/equipmentselection", http, environmentService);
    this.eventPaymentTypes = new CodebookElement<Lookups>("/api/public/lookups/eventpaymenttype", http, environmentService);
    this.eventPaymentMethods = new CodebookElement<Lookups>("/api/public/lookups/eventpaymentmethod", http, environmentService);
    this.eventPaymentReminderMethods = new CodebookElement<Lookups>("/api/public/lookups/eventpaymentremindermethod", http, environmentService);
    this.leaguesCountries = new CodebookElement<Lookups>("/api/public/leagues/countries", http, environmentService);
    this.leaguesSports = new CodebookElement<Lookups>("/api/public/leagues/sports", http, environmentService);
  }
}

export class CodebookElement<T> {
  private valueSubject: BehaviorSubject<T[] | null> = new BehaviorSubject<T[] | null>(null);

  constructor(private endpointURL: string, private http: HttpClient, private environmentService:EnvironmentService) {
  }

  get value(): Observable<T[]> {
    if (this.valueSubject.value && this.valueSubject.value?.length > 0) {
      return of(this.valueSubject.value);
    } else {
      return this.http.get<ActionResult<T[]>>(this.environmentService.getApiUrl() + this.endpointURL).pipe(map((actionResult: ActionResult<T[]>) => {
          if (actionResult && actionResult.result && actionResult.result.length > 0) {
            this.valueSubject.next(actionResult.result);
            return actionResult.result;
          } else {
            this.valueSubject.next([]);
            return [];
          }
        })
      );
    }
  }
}
